import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewbox="0 0 12 12" fill="none"><rect width="12" height="12" fill="#F3A722" rx="3"></rect><path fill="#0E1015" d="M5.542 1h.271c.19.073.37.174.535.289.053.22.145.453.066.677-.068.062-.16.088-.243.126.01.086.024.172.038.258.155-.013.305-.053.457-.082.021-.089.026-.186.084-.262.012.06.022.122.03.183.081.047.16.113.261.103.638 0 1.276-.002 1.913 0 .07-.005.104.068.152.106.001-.134 0-.267.007-.401l.075.001c.004.118-.009.238.025.353.035.008.071.01.108.015l.006.137c.196.006.394.019.588-.014.13-.02.263-.006.395-.006a.911.911 0 0 0 .015.137 2.087 2.087 0 0 1-.49-.004c-.259-.032-.518.023-.777.008l-.025.104c-.249.003-.498-.001-.746 0-.083-.002-.174.016-.226.084-.073.09-.162.167-.232.26-.023.169.044.333.083.495-.059.021-.118.04-.176.062-.059.183-.035.417-.205.546-.094.069-.177.156-.284.205-.078.035-.162-.002-.24-.013-.293-.044-.535-.22-.796-.343-.017.07-.036.139-.055.208.08.05.181.093.207.193.04.145.007.298.001.446-.012.136-.016.273-.029.409-.013.132-.09.245-.17.348-.074-.018-.147-.04-.22-.058-.08.167-.014.376.117.5.34.365.523.833.696 1.29.029.096.13.153.147.255.028.108.068.216.059.329-.013.198-.028.397-.048.595-.014.145-.069.29-.036.437a.655.655 0 0 1-.006.363c-.06.147-.06.307-.06.463.003.103.009.216.08.297.086.104.17.212.272.3.127.082.301.083.405.201.033.065.01.14.009.21-.33.049-.673.052-.992-.049-.18-.058-.38.041-.552-.056a1.9 1.9 0 0 1 .132-.592c.03-.142-.003-.288-.006-.432-.002-.124-.067-.233-.091-.352a3.514 3.514 0 0 1-.104-.786c-.016-.13.095-.228.1-.354a.39.39 0 0 0-.064-.32c-.123-.004-.288.027-.356-.102-.144-.21-.283-.421-.426-.63-.05-.09-.17-.07-.251-.109-.074-.066-.11-.16-.155-.245a.59.59 0 0 1-.137.268c-.114.114-.156.272-.215.416-.042.104-.08.211-.095.322-.016.085-.02.183-.096.238-.112.084-.152.225-.255.318a.551.551 0 0 0-.149.269c-.008.09.019.181-.004.27-.042.163-.133.307-.2.46-.047.107-.072.223-.124.329-.034.074-.123.098-.172.16a1.17 1.17 0 0 0-.135.798c.04.107.07.22.045.335-.087.012-.172.026-.26.034H2.75c-.07-.014-.142-.025-.205-.058a.781.781 0 0 1 .003-.455c.063-.222.12-.445.176-.667.039-.11-.052-.208-.044-.317-.009-.16.092-.294.165-.428.069-.12.045-.264.092-.39.108-.273.312-.496.433-.763.038-.109-.003-.224.004-.336.01-.213.052-.422.09-.631.012-.08.038-.166.006-.245a.638.638 0 0 1-.044-.296c.014-.093-.042-.185-.007-.276.019-.077.09-.12.148-.168.01-.316-.106-.627-.057-.942.055-.069.145-.093.223-.128a25.728 25.728 0 0 1-.342-.072 1.528 1.528 0 0 1 .04-.378c.042-.194.018-.395.05-.59.005-.05.06-.067.103-.069.104-.007.209-.012.31-.037-.03-.247-.055-.499.001-.744.055-.29.187-.585.434-.764.17-.113.415-.18.593-.045l.058-.039a.933.933 0 0 1 .084-.84c.106-.168.292-.264.478-.322Zm1.667 1.889c-.01.072-.032.143-.102.177.093-.006.187-.005.279-.025l-.006-.158a6.353 6.353 0 0 0-.171.006Zm-.192.203-.032.04c.014.097.088.177.137.261.072-.099.144-.198.213-.3-.106-.005-.213-.012-.318-.001Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
